// eslint-disable-next-line no-restricted-imports
import { name, version } from '../package.json';
import App from '@/App.vue';
import { i18n } from '@/translations/i18n';
import { iFrameApi } from '@/obsidianApi/api';
import { detectClientSlug } from '@/utils/detectClientSlug';
import { getClientBySlug } from '@/clients/clientRegistry';
import { initErrorMonitoring } from '@/services/errorMonitoring';
import { loadRuntimeConfig } from '@/bootstrap/loadRuntimeConfig';
import { resolveInitialLocale } from '@/bootstrap/resolveInitialLocale';
import { installTestApi } from '@/testApi/installTestApi';
import { useClientStore } from '@/store/client.store';
import { router } from '@/router/router';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import '@/utils/polyfill';
import '@/assets/style/main.css';

const app = createApp(App);

initErrorMonitoring(app);

const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(i18n);

// Applied here rather than in initStore, which runs in EditorView only: login, product
// selection and admin render before it. Once, too -- initStore is re-run on template
// change, and re-applying the host value there would revert the user's own choice.
i18n.global.locale.value = resolveInitialLocale(loadRuntimeConfig().lang);

const clientTheme = getClientBySlug(detectClientSlug());
useClientStore(pinia).setTheme(clientTheme);

app.mount('#app');

if (import.meta.env.DEV) {
    installTestApi();
}

// Tells the integration that the app is ready
iFrameApi.ready();

console.info(`${name} - v${version}`);
